import { Box, Button, ConditionWrapper, ConnectQuickBooksButton } from '@approvalmax/ui/src/components';
import { domain } from 'modules/data';
import { FC, memo } from 'react';

import { useButtonNext } from './ButtonNext.hooks';
import { ButtonNextProps } from './ButtonNext.types';

export const ButtonNext: FC<ButtonNextProps> = memo((props) => {
    const { integrationType, onClick } = props;

    const { buttonText, minWidth } = useButtonNext(integrationType);

    const isQbooks = integrationType === domain.IntegrationType.QBooks;

    if (isQbooks) {
        return <ConnectQuickBooksButton onClick={onClick} size='large' />;
    }

    return (
        <ConditionWrapper condition={!!minWidth} wrapperIf={(children) => <Box minWidth={minWidth}>{children}</Box>}>
            <Button color='blue80' block={!!minWidth} size='large' onClick={onClick}>
                {buttonText}
            </Button>
        </ConditionWrapper>
    );
});

ButtonNext.displayName = 'ButtonNext';
